module.exports = __webpack_public_path__ + "static/media/gogreener_adoptree_jejakin.6ccffc9b.svg";